import angular from 'angular'
import originalAccount from './originalAccount'
import selection4th from './selection4th'
import drawback from './drawback'

export default angular
    .module('input.specialInvoiceCertification', [originalAccount, selection4th, drawback])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('input.certification', {
            abstract: true,
            url: '/certification',
            template: '<div ui-view></div>',
            title: '专票认证处理',
        })
    }])
    .name


// WEBPACK FOOTER //
// ./src/app/input/specialInvoiceCertification/index.js